<template>
  <div class="game-text-block-with-input" :style="getMainStyle(startGameConfig)">
    <div v-if="objectImageExist(imageData)" class="main-image-container" :style="getImageStyle(imageData)"></div>
    <div class="text-block" :style="getStyle()" v-html="textBlock"></div>
    <tr-box
      v-if="words.length"
      :items="words"
      :config="boxConfig"
      :font-size="boxConfigFontSize"
      class="box-style"
    ></tr-box>
  </div>
</template>

<script>
// HACK: Przepisać komponent bo mix z jQuery teraz jest
import _ from 'lodash';
import $ from 'jquery';
import defaultMixin from '../../mixins/defaultMixin';
import * as utils from '../../Utils/inputUtils';
// import stringParser from '../../Utils/stringParser';
import TrBox from '../../GameBaseElements/TrBox/TrBox';
export default {
  name: 'tr-text-block-with-input',
  components: { TrBox },
  props: {
    startGameConfig: {
      type: Object,
      default: function() {
        return {};
      },
    },
  },
  mixins: [defaultMixin],
  data() {
    return {
      textBlock: '',
      imageData: {},
      MAGIC_PROPERTY: '',
      words: [],
      boxConfig: {},
      inputStyle: {},
    };
  },
  beforeCreate() {},
  created() {
    /** @type {String} prasing text with placeholder {{placeholder}} */
    this.data = this.prepareBlockData(this.startGameConfig);
    this.MAGIC_PROPERTY = _.cloneDeep(this.data.MAGIC_PROPERTY || 0.75);
    (this.words = _.shuffle(_.cloneDeep(this.data.words))), (this.textBlock = this.data.text);
    this.textBlock = this.stringParser(this.textBlock);
    this.boxConfig = {
      x: (this.data.boxConfig && this.data.boxConfig.left) || 1,
      y: (this.data.boxConfig && this.data.boxConfig.top) || 14,
      width: (this.data.boxConfig && this.data.boxConfig.width) || 98,
      height: (this.data.boxConfig && this.data.boxConfig.height) || 12,
      unit: '%',
      wordConfig: (this.data.boxConfig && this.data.boxConfig.wordConfig) || {},
    };
    this.inputStyle = {
      italic: (this.data.inputStyle && this.data.inputStyle.italic) || false,
      correctIndex: (this.data.inputStyle && this.data.inputStyle.correctIndex) || 0,
    };
    if (this.data.mainImage) {
      this.imageData = this.data.mainImage;
    } else if (this.data.background) {
      this.imageData = Object.assign({}, { imagePath: this.data.background });
    }
  },
  beforeMount() {},
  mounted() {
    //**max number of char in input round(the longest word + 20% )
    let self = this;
    $('.inline-input').each(function(item) {
      $(this).attr('maxlength', String(_.round(self.maxLength * 1.2)));
    });
    /**
     * removing error class on focus
     * @method
     */
    $('.inline-input').focus(function() {
      $(this).removeClass('inline-input-wrong');
      self.resetCheckStatus();
    });
  },
  methods: {
    prepareBlockData(data) {
      if (data.pick && data.items) {
        let items = data.shuffle ? _.shuffle(_.cloneDeep(data.items)) : _.cloneDeep(data.items);
        let preparedData = _.sampleSize(items, data.pick);
        if (_.isArray(preparedData)) {
          preparedData = preparedData[0];
        }
        return preparedData;
      } else {
        return _.cloneDeep(data);
      }
    },
    /**
     * parsing text - replace markers by input with id and data-key
     * @method stringParser
     * @param  {String}     text text with placeholder
     * @return {String}          text with HTML input tag
     */
    stringParser(text) {
      let regExp = /{{(.+?)}}/g;
      let test = text.match(regExp);
      let elements = _.map(test, (item, index) => {
        let rowItem = _.clone(item);
        let italic = /#i#/.test(item);
        item = item.replace(/#i#/, '');
        let rowWords = item.replace(/({{)|(}})/g, '');
        let allWords = rowWords.split('/');
        return {
          allWords,
          textToReplace: rowItem,
          index,
          italic,
        };
      });
      /**
       * max number of  leter in words
       * @type {String}
       */
      this.maxLength = _.max(
        _.flattenDeep(
          _.map(elements, (item) => {
            if (_.isArray(item.allWords)) {
              return _.map(item.allWords, (innerElem) => {
                return innerElem.length;
              });
            } else {
              return item.allWords.length;
            }
          })
        )
      );
      /**
       * replace placeholder
       * @type {Array}
       */
      _.each(elements, (item, index) => {
        // TODO:wymienić na element używający componetów
        // TODO:max liczba znakow
        let textStyle = this.inputStyle.italic ? 'font-style: italic;' : '';
        if (item.italic) {
          textStyle = 'font-style: italic;';
        }
        if (this.data.input) {
          let customTextStyle = this.getCustomStyle(this.data.input);
          let customTextStyleString = '';
          _.each(customTextStyle, (value, key) => {
            customTextStyleString += [String(key), ':', String(value), ';'].join('');
          });
          textStyle = [textStyle, customTextStyleString].join('');
        }
        let data = [
          'width',
          ':',
          _.round(this.maxLength * this.MAGIC_PROPERTY, 2),
          'em',
          ';',
          'height: 1.5em;',
          textStyle,
        ].join('');
        text = text.replace(
          item.textToReplace,
          `<input id="input_${index}" style="${data}" data-correct-word="${item.allWords}" class="inline-input"/>`
        );
        // text = text.replace(item.textToReplace, ` <tr-input style="${data}" class="inline-input"></tr-input>`);
        // text = text.replace(item.textToReplace, ` <span style="color:red;">DUPA</span>`);
      });
      return text;
    },
    /**
     * reset all containerEnd without reset reactivity
     * @method resetGameAction
     */
    resetGameAction() {
      // _.each( this.selected, ( item, key, collection ) => {
      //   collection[ key ] = "";
      // } );
      this.resetCheckStatus();
      this.words = _.shuffle(_.cloneDeep(this.data.words));
      let data = document.getElementsByClassName('inline-input');
      _.each(data, (item, index) => {
        $(item).val((index, itemValue) => {
          return '';
        });
        $(item).prop('disabled', false);
        $(item).removeClass('inline-input-correct');
        $(item).removeClass('inline-input-wrong');
        $(item).removeClass('inline-input-disabled');
      });
    },
    checkGameAction() {
      let data = document.getElementsByClassName('inline-input');
      // console.log('test', $(data).val() === $(data).attr('data-correct-word'));
      let status = _.reduce(
        data,
        (result, value, key) => {
          let temVal = null;
          // console.log('test', $(value).val() === $(value).attr('data-correct-word'));
          $(value).val((index, itemValue) => {
            return _.trim(itemValue);
          });
          let tVal = $(value).val();
          let allWords = $(value)
            .attr('data-correct-word')
            .split(',');
          let index = _.findIndex(allWords, (o) => {
            return o === tVal;
          });
          if (index != -1) {
            temVal = result && true;
            $(value).removeClass('inline-input-wrong');
            $(value).prop('disabled', true);
            $(value).addClass('inline-input-disabled');
            $(value).addClass('inline-input-correct');
            if (this.data.replaceAfterCorrect) {
              $(value).val((index, itemValue) => {
                return allWords[this.inputStyle.correctIndex] ? allWords[this.inputStyle.correctIndex] : allWords[0];
              });
            }
          } else {
            temVal = false;
            $(value).addClass('inline-input-wrong');
            let blink = function(duration = 0) {
              return new Promise((resolve, reject) => {
                $(value).addClass('inline-input-wrong');
                setTimeout(resolve, duration);
              });
            };
            blink(1000).then(() => {
              $(value).removeClass('inline-input-wrong');
              $(value).val((index, itemValue) => {
                return '';
              });
            });
          }
          return temVal;
        },
        true
      );
      console.log('ANSWER: ', status);
      if (!status) {
        _.each(data, (item, key) => {
          console.log('item', $(item).val());
        });
      }
      return status;
    },
    onKeyDown(evt) {
      // console.log( 'onKeyDown' );
      if (this.value.length >= this.max) {
        if (evt.keyCode >= 48 && evt.keyCode <= 90) {
          evt.preventDefault();
          return;
        }
      }
    },
    getMainStyle(item) {
      let width = '1920px';
      let height = '1080px';
      if (item && item.cssStyle) {
        (width = item.cssStyle.width || width), (height = item.cssStyle.height || height);
      }
      return _.merge({}, { width: width, height: height }, this.getCustomStyle(item));
    },
    getStyle() {
      // padding: 5%;
      // margin-top: 12%;
      return _.assign(this.getCustomStyle(this.data), {
        padding: this.data.padding + '%',
        'margin-top': this.data.marginTop + '%',
      });
    },
    getCustomStyle(item) {
      let customStyle = {};
      if (item.cssStyle) {
        if (_.isObject(item.cssStyle)) {
          customStyle = _.mapKeys(item.cssStyle, function(value, key) {
            return _.toString(key);
          });
        }
      }
      return customStyle;
      // return {
      //   'width': (item.textBlockWidth) ? utils.elementWidth(item.textBlockWidth) : utils.elementWidth(this.data.textBlockWidth),
      //   'height': (item.textBlockHeight) ? utils.elementHeight(item.textBlockHeight) : utils.elementHeight(this.data.textBlockHeight),
      //   'justify-content': (item.flexJustify) ? 'center' : item.flexJustify,
      // };
    },
    /**
     * test if object objectExist
     * @method objectExist
     * @param  {*}    item testiing element
     * @return {Boolean}         true if is object
     */
    objectImageExist(item) {
      return _.isObject(item) && !_.isNil(item.imagePath);
    },
    getImage(item) {
      return 'static/' + item.imagePath;
      // return 'assets/config/' + item.imagePath;
    },
    getImageStyle(imageData) {
      if (_.isObject(imageData) && imageData.imagePath) {
        if (!imageData.position) {
          imageData = Object.assign({}, imageData, {
            position: '',
          });
        }
        if (!imageData.pos) {
          imageData = Object.assign({}, imageData, {
            pos: {
              x: 0,
              y: 0,
            },
          });
        }
        if (!imageData.height) {
          imageData = Object.assign({}, imageData, {
            height: 358,
          });
        }
        if (!imageData.width) {
          imageData = Object.assign({}, imageData, {
            width: 1850,
          });
        }
      }

      return {
        'background-image': `url(${require(`__staticDir/${this.$store.getters.multibookType}/${imageData.imagePath}`)})`,
        top: utils.elementTopPosition(imageData.pos.y, imageData.offsetVertical),
        left: utils.elementLeftPosition(imageData.pos.x, imageData.offsetHorizontal),
        position: imageData.position,
        width: utils.elementWidth(imageData.width),
        height: utils.elementHeight(imageData.height),
      };
    },
  },
  computed: {
    boxConfigFontSize() {
      let fontSize = this.data.boxConfig && this.data.boxConfig.fontSize;
      return fontSize + 'px';
    },
  },
};
</script>
<!-- HACK: nie da sie zastosować  stylu o ograniczonym zasiegu -->
<style lang="scss">
@import '~@/assets/sass/variable';
@import '~@/assets/sass/iconColor';
@import '~@/assets/sass/inputBase';
@import '~@/assets/sass/textBlockWithInput';
</style>
<style lang="scss" scoped>
.game-text-block-with-input {
  overflow: hidden;
  height: 100%;
  .main-image-container {
    position: relative;
    display: block;
    width: 100%;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  .text-block {
    overflow-y: auto;
  }
}
</style>
